import React from 'react';

interface SurveyProgressBarProps {
  current: number;
  total: number;
  primaryColor: string;
}

export const SurveyProgressBar: React.FC<SurveyProgressBarProps> = ({
  current,
  total,
  primaryColor,
}) => {
  const progress = ((current + 1) / total) * 100;

  return (
    <div className="mt-6">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm text-gray-600">
          Page {current + 1} of {total}
        </span>
        <span className="text-sm text-gray-600">
          {Math.round(progress)}% Complete
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className="h-2 rounded-full transition-all duration-300"
          style={{
            width: `${progress}%`,
            backgroundColor: primaryColor,
          }}
        />
      </div>
    </div>
  );
};